import React, { useState } from 'react';
import { Box, Button, Card, Flex, Heading, Text, Image } from 'rebass';
import styled from 'styled-components';
import GutResetIntro from '../../../static/GutResetIntro.png';
import { HowItWorks } from './HowItWorks';
import { PricingCards } from './PricingCards';
import { SignsCard } from './SignsCards';
import { withRouter } from 'react-router-dom';
import withSession from '../../../lib/withSession';
import { useEffect } from 'react';

const HeaderContainer = styled(Flex)`
  width: 100%;
  flex-direction: row;

  @media screen and (max-width: 52em) {
    flex-direction: column-reverse;
  }
`;

const Expandable = ({ title, text }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Flex flexDirection={'column'} style={{ width: '100%', cursor: 'pointer', borderBottom: '1px solid #B5C2D6' }} mb={3}>
      <Flex
        alignItems={'center'}
        style={{ gap: '20px' }}
        onClick={() => {
          setIsExpanded(v => !v);
        }}
      >
        <Text flex={1} style={{ fontSize: '15px', fontWeight: 500 }}>
          {title}
        </Text>
        <Text style={{ fontSize: '33px', fontWeight: 300 }}>+</Text>
      </Flex>
      {isExpanded && (
        <Text style={{ fontSize: 14, marginTop: 8, fontWeight: 400, whiteSpace: 'pre-line' }} mb={3}>
          {text}
        </Text>
      )}
    </Flex>
  );
};

const ConsequenceCard = ({ text }) => {
  return (
    <Card style={{ padding: '13px 18px', borderRadius: '18px' }}>
      <Flex alignItems={'center'}>
        <svg width="20" height="27" viewBox="0 0 20 27" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18.8496 0.5L12.4385 9.96387L11.9102 10.7441H15.8887L1.40039 24.5303L7.19922 10.8584L7.50488 10.1396L6.72363 10.1641L0.920898 10.3428L7.01758 0.5H18.8496Z"
            fill="#EBB6A7"
            stroke="#344F7A"
          />
        </svg>

        <Text ml={'12px'} style={{ fontSize: '14px' }}>
          {text}
        </Text>
      </Flex>
    </Card>
  );
};

export const NotSubscribed = withRouter(
  withSession(({ history, session }) => {
    useEffect(() => {
      if (!!session && !!session.isGiMember) {
        history.push('/programs/gut-reset');
      }
    }, []);
    const expandables = [
      {
        title: '1:1 ongoing access to your provider',
        text:
          'Stay connected between visits. Message your nutritionist directly whenever questions come up, get help interpreting symptoms, and receive guidance as you move through your personalized protocol.',
      },
      {
        title: 'Personalized treatment plan',
        text:
          'Your provider will design a step-by-step plan based on your symptoms, test results, and goals. This includes nutrition guidance, supplement recommendations, and lifestyle adjustments tailored to your gut health needs.',
      },
      {
        title: 'Come with your GI lab results or get exclusive pricing on GI test kit',
        text:
          "Already have recent GI testing? Great — we'll use it. If not, you’ll get preferred pricing on our comprehensive GI test kit, which gives you a detailed picture of your microbiome, inflammation markers, digestion, and more.",
      },
      {
        title: 'Comprehensive support throughout your gut reset journey',
        text:
          'We help you translate insights into action. From reviewing your progress to adjusting your plan as your symptoms improve, your provider is with you every step of the way to ensure lasting results.',
      },
    ];
    const faq = [
      {
        title: 'Do I need the GI test kit?',
        text: 'No — you can join with or without a test. If you already have a GI-MAP or Genova test from the last 12 months, you can upload it.',
      },
      {
        title: 'How long is the program?',
        text: 'You can choose 3, 6, or 9 months. Six months is our most popular option.',
      },
      {
        title: 'How quickly will I get my test kit?',
        text: 'Kits ship in 1–2 business days, and you’ll get tracking updates by email.',
      },
      {
        title: 'How long do results take?',
        text: 'Most results are ready 3–4 weeks after the lab receives your sample.',
      },
      {
        title: 'Is the sample collection difficult?',
        text: 'No — it takes just a few minutes, and no refrigeration is needed.',
      },
      {
        title: 'What’s included in the program?',
        text: 'A personalized gut-focused plan, supplement guidance, monthly nutrition visits, and unlimited messaging with your care team.',
      },
      {
        title: 'Is this covered by insurance?',
        text: 'Not at this time — the program is self-pay only.',
      },
      {
        title: 'Can I switch plans later?',
        text: 'Yes. You can upgrade to include a GI test kit or extend your program anytime.',
      },
      {
        title: 'What will I have to pay?',
        text: `probiotic , viamins, etc. cost not included\nadditional labs like SIBO breath test not included`,
      },
      {
        title: 'What’s not included?',
        text: `Your monthly membership covers visits, messaging access, and your personalized gut protocol.\n
Some items are optional add-ons and not included in the monthly price:\n
• Probiotics, vitamins, and supplements\n
• Additional specialty labs (e.g., SIBO breath test, hormone panels, food sensitivity testing)\n
• Any third-party pharmacy or lab fees\n\n

Your provider will always review costs with you before recommending anything optional.`,
      },
      
      {
        title: 'Can the GI tests be reimbursed by insurance?',
        text: `These tests are not physician-ordered diagnostics and unfortunately cannot be billed to or reimbursed by insurance. As a result, it is not possible to have them ordered through insurance and reviewed as part of the program. That said, our team can still review results from these tests within the Gut Reset Program and incorporate them into your care plan.`,
      },
      {
        title: 'Should I buy my microbiome test from a specific company? ',
        text: (<>
        For the microbiome component, we are test-agnostic, but our preferred partner is{' '}
        <a href="https://store.tinyhealth.com/discount/PALOMA?redirect=/products/adult-gut-health-test" target="_blank" rel="noopener noreferrer">
          Tiny Health
        </a>. Their test is a stool-based microbiome test that looks at gut bacteria and overall balance. You can find full details on the Tiny Health website, and we do offer a discount code: PALOMA.
      </>)
        // text: `For the microbiome component, we are test-agnostic, but our preferred partner is Tiny Health. Their test is a stool-based microbiome test that looks at gut bacteria and overall balance. You can find full details on the Tiny Health website, and we do offer a discount code: PALOMA.`,
      },
      {
        title: 'Where should I buy a breath test?',
        text: (<>
        For breath testing, we recommend{' '}
        <a href="https://foodmarble.com/store?discount_code=PALOMA" target="_blank" rel="noopener noreferrer">
          FoodMarble’s device
        </a>, which is a breath test used to assess fermentation and gas production related to digestion. More information is available on FoodMarble’s website, and we have a Paloma discount code: PALOMA.
      </>)
        //text: `For breath testing, we recommend FoodMarble’s device, which is a breath test used to assess fermentation and gas production related to digestion. More information is available on FoodMarble’s website, and we have a Paloma discount code: PALOMA.`,
      },

    ];

    return (
      <Flex flexDirection={'column'} style={{ maxWidth: '800px' }} mt={'30px'} mb={'80px'} p={['0 12px', '0 24px', '0 0']}>
        <HeaderContainer>
          <Flex flexDirection={'column'} flex={1}>
            <Heading style={{ fontSize: '32px' }}>
              Heal Your Gut.
              <br />
              Reset Your Health.
            </Heading>
            <svg width="82" height="5" viewBox="0 0 82 5" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.0894775 2.66456C28.0332 0.993652 61.2703 0.993576 81.0895 3.50002" stroke="#F4A295" strokeWidth="3" />
            </svg>

            <Text mt={4} mb={4}>
              Your gut does more than digest food — it influences your hormones, thyroid, mood, and metabolism. <br />
              <br />
              Our GUT Reset Program is a science-based approach to restoring gut balance and supporting your thyroid and hormonal health from the inside out.
            </Text>

            <Button
              variant={'primary'}
              style={{
                alignSelf: 'flex-start',
                fontWeight: 300,
                padding: '8px 42px',
              }}
              onClick={() => {
                history.push('/programs/gut-reset/subscribe');
              }}
            >
              Start Now
            </Button>
          </Flex>
          <Image src={GutResetIntro} style={{ marginLeft: '32px' }} alignSelf={['center', 'flex-start']} alt="" mb={[3, 0]} />
        </HeaderContainer>

        <Flex style={{ backgroundColor: '#E7F0FF', borderRadius: '10px', padding: '14px 22px', position: 'relative' }} mt={5} mb={5}>
          <Flex flexDirection={'column'} flex={1}>
            <svg width="66" height="58" viewBox="0 0 66 58" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M61.8638 45.8236C59.1599 49.1364 55.7839 51.3647 52.1737 53.2227C43.4741 57.7004 34.3106 58.7657 24.7504 56.7789C22.8071 56.375 20.8215 56.1619 18.8484 55.9182C15.3202 55.4816 12.0717 54.3284 9.42122 51.9195C6.40485 49.1779 4.24166 45.8007 2.77937 41.9973C-0.0773655 34.5654 -0.915292 26.9726 1.13076 19.1846C1.85509 16.4263 3.27434 13.9999 4.74125 11.5764C6.92052 7.97442 9.91019 5.18423 13.248 2.74551C15.3118 1.23785 17.7754 0.644334 20.2788 0.388373C30.0501 -0.608455 39.6438 0.286591 48.9835 3.38677C50.6768 3.9489 52.4815 4.61473 53.809 5.73845C55.7592 7.44716 57.5184 9.3629 59.0558 11.452C61.7063 14.9394 63.1545 19.0108 64.0681 23.2658C65.0433 27.8106 65.8461 32.3854 65.3324 37.0628C64.972 40.3357 63.6233 43.2381 61.8638 45.8236Z"
                fill="#F5E4DD"
              />
              <g clipPath="url(#clip0_13_1100)">
                <path
                  d="M36.7092 31.8081C38.335 31.8081 39.8943 31.1622 41.044 30.0126M36.7092 31.8081C35.0833 31.8081 33.524 31.1622 32.3744 30.0126M36.7092 31.8081V36.4058M41.044 30.0126C42.1936 28.8629 42.8395 27.3036 42.8395 25.6778M41.044 30.0126L44.2948 33.2634M42.8395 25.6778C42.8395 24.0519 42.1936 22.4926 41.044 21.343M42.8395 25.6778H47.4372M41.044 21.343C39.8943 20.1933 38.335 19.5474 36.7092 19.5474M41.044 21.343L44.2948 18.0899M36.7092 19.5474C35.0833 19.5474 33.524 20.1933 32.3744 21.343M36.7092 19.5474V14.9497M32.3744 21.343C31.2247 22.4926 30.5788 24.0519 30.5788 25.6778M32.3744 21.343L29.1235 18.0899M30.5788 25.6778C30.5788 27.3036 31.2247 28.8629 32.3744 30.0126M30.5788 25.6778H25.9811M32.3744 30.0126L29.1235 33.2634M35.6889 14.9497H37.7316M43.5727 17.3678L45.0191 18.8143M47.4372 24.6553V26.698M45.0191 32.5413L43.5727 33.9855M37.7316 36.4058H35.6889M29.8457 33.9855L28.4014 32.5413M25.9811 26.698V24.6553M28.4014 18.8143L29.8457 17.3678"
                  stroke="#EBB6A7"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M23.85 53.3437C23.9772 50.5125 24.5943 47.7248 25.6741 45.1045C34.7945 46.6172 50.5421 41.538 55.2658 32.093C61.5838 19.4458 50.573 3.72471 36.0334 6.14725C31.6787 6.88335 27.621 8.83637 24.3292 11.7807C21.571 9.17267 21.4584 8.18333 19.2059 3.65625M7.91467 3.65625C9.81586 10.0353 13.1003 15.9166 17.5342 20.8812C14.4513 27.3517 13.95 34.4625 16.3792 39.1618C14.0119 43.5244 12.7033 48.3824 12.5588 53.3437"
                  stroke="#344F7A"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_13_1100">
                  <rect width="53" height="53" fill="white" transform="translate(6 2)" />
                </clipPath>
              </defs>
            </svg>
            <Heading mt={3} mb={3}>
              Your gut is your body’s internal defense system
            </Heading>

            <Text>
              When your microbial ecosystem is disrupted by toxins introduced by processed foods or antibiotics, your gut barrier can become inflamed and make you vulnerable to illness and chronic
              conditions.
            </Text>

            <Box style={{ position: 'absolute', top: '-70px', right: '-90px' }}>
              <svg width="231" height="244" viewBox="0 0 231 244" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M123.326 129.936C118.198 121.898 118.612 108.343 126.318 98.5021C132.104 91.1135 143.812 85.6218 152.441 89.2922C168.156 95.9771 169.159 112.217 157.418 121.616C149.025 128.335 136.533 150.637 123.326 129.936Z"
                  fill="#FFE3D8"
                />
                <path
                  d="M166.169 164.998C164.714 174.422 155.453 184.329 143.169 186.632C133.945 188.361 121.525 184.755 117.468 176.302C110.078 160.905 120.047 148.046 135.071 148.739C145.811 149.234 169.917 140.731 166.169 164.998Z"
                  fill="#FFE3D8"
                />
                <path
                  d="M95.2532 144.756C85.9905 147.02 73.2925 142.258 66.4613 131.791C61.3321 123.933 59.9079 111.079 66.1638 104.094C77.5576 91.3725 93.2536 95.6576 98.3661 109.802C102.021 119.913 119.106 138.927 95.2532 144.756Z"
                  fill="#FFE3D8"
                />
                <path
                  d="M123.567 61.9185C127.18 67.9656 126.579 77.9657 120.676 85.0647C116.243 90.395 107.478 94.1959 101.186 91.2983C89.7273 86.0211 89.339 74.008 98.2127 67.3226C104.556 62.5433 114.264 46.3463 123.567 61.9185Z"
                  fill="#FFE3D8"
                />
                <path
                  d="M78.1612 63.6151C76.8519 70.5363 69.7678 77.62 60.6407 79.0144C53.7876 80.0613 44.7081 77.0897 41.9231 70.7473C36.851 59.1959 44.5311 49.9502 55.606 50.836C63.5232 51.4692 81.5329 45.7918 78.1612 63.6151Z"
                  fill="#FFE3D8"
                />
              </svg>
            </Box>
          </Flex>
        </Flex>
        <Heading mt={4} mb={4}>
          Why Gut Health Matters for Thyroid and Hormones
        </Heading>

        <Flex flexDirection={['column', 'row']} style={{ gap: '54px' }}>
          <Flex flex={1} flexDirection={'column'} style={{ gap: '12px' }}>
            <Text mb={3}>
              Consequences of poor gut health:
            </Text>
            {['Worsen Hypothyroidism', 'Drive inflammation', 'Disrupt nutrient absorption', 'Throw your hormones off balance'].map((x) => (
              <ConsequenceCard text={x} tag={x} />
            ))}
          </Flex>
          <Flex flex={1} flexDirection={'column'} style={{ gap: '12px' }}>
            <Text mb={3}>
              Signs of poor gut health:
            </Text>
            <Flex flexDirection={['column', 'row']} flexWrap={'wrap'} style={{ gap: '12px' }}>
              {['Bloating', 'Irregular digestion', 'Fatigue', 'Brain Fog'].map((x) => (
                <SignsCard text={x} tag={x} />
              ))}
            </Flex>
          </Flex>
        </Flex>
        <Heading mt={4} mb={4}>
          Built to Support You From A to Z
        </Heading>
        <Flex flexDirection={['column', 'row']} style={{ gap: '40px' }}>
          <Flex flexDirection={'column'} style={{ maxWidth: '290px', width: '290px' }} alignSelf={['center', 'flex-start']}>
            <Card style={{ padding: '14px', maxHeight: 'fit-content', borderRadius: '10px' }}>
              <Flex flexDirection={'column'}>
                <svg width="66" height="58" viewBox="0 0 66 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M61.8638 45.8236C59.1599 49.1364 55.7839 51.3647 52.1737 53.2227C43.4741 57.7004 34.3106 58.7657 24.7504 56.7789C22.8071 56.375 20.8215 56.1619 18.8484 55.9182C15.3202 55.4816 12.0717 54.3284 9.42122 51.9195C6.40485 49.1779 4.24166 45.8007 2.77937 41.9973C-0.0773655 34.5654 -0.915292 26.9726 1.13076 19.1846C1.85509 16.4263 3.27434 13.9999 4.74125 11.5764C6.92052 7.97442 9.91019 5.18423 13.248 2.74551C15.3118 1.23785 17.7754 0.644334 20.2788 0.388373C30.0501 -0.608455 39.6438 0.286591 48.9835 3.38677C50.6768 3.9489 52.4815 4.61473 53.809 5.73845C55.7592 7.44716 57.5184 9.3629 59.0558 11.452C61.7063 14.9394 63.1545 19.0108 64.0681 23.2658C65.0433 27.8106 65.8461 32.3854 65.3324 37.0628C64.972 40.3357 63.6233 43.2381 61.8638 45.8236Z"
                    fill="#F5E4DD"
                  />
                  <g clipPath="url(#clip0_13_1050)">
                    <path
                      d="M36.7092 31.8081C38.335 31.8081 39.8943 31.1623 41.044 30.0126M36.7092 31.8081C35.0833 31.8081 33.524 31.1623 32.3744 30.0126M36.7092 31.8081V36.4059M41.044 30.0126C42.1936 28.8629 42.8395 27.3037 42.8395 25.6778M41.044 30.0126L44.2948 33.2634M42.8395 25.6778C42.8395 24.0519 42.1936 22.4927 41.044 21.343M42.8395 25.6778H47.4372M41.044 21.343C39.8943 20.1933 38.335 19.5475 36.7092 19.5475M41.044 21.343L44.2948 18.09M36.7092 19.5475C35.0833 19.5475 33.524 20.1933 32.3744 21.343M36.7092 19.5475V14.9497M32.3744 21.343C31.2247 22.4927 30.5788 24.0519 30.5788 25.6778M32.3744 21.343L29.1235 18.09M30.5788 25.6778C30.5788 27.3037 31.2247 28.8629 32.3744 30.0126M30.5788 25.6778H25.9811M32.3744 30.0126L29.1235 33.2634M35.6889 14.9497H37.7316M43.5727 17.3678L45.0191 18.8143M47.4372 24.6553V26.698M45.0191 32.5413L43.5727 33.9855M37.7316 36.4059H35.6889M29.8457 33.9855L28.4014 32.5413M25.9811 26.698V24.6553M28.4014 18.8143L29.8457 17.3678"
                      stroke="#EBB6A7"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M23.85 53.3437C23.9772 50.5125 24.5943 47.7248 25.6741 45.1045C34.7945 46.6172 50.5421 41.538 55.2658 32.093C61.5838 19.4458 50.573 3.72471 36.0334 6.14725C31.6787 6.88335 27.621 8.83637 24.3292 11.7807C21.571 9.17267 21.4584 8.18333 19.2059 3.65625M7.91467 3.65625C9.81586 10.0353 13.1003 15.9166 17.5342 20.8812C14.4513 27.3517 13.95 34.4625 16.3792 39.1618C14.0119 43.5244 12.7033 48.3824 12.5588 53.3437"
                      stroke="#344F7A"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_13_1050">
                      <rect width="53" height="53" fill="white" transform="translate(6 2)" />
                    </clipPath>
                  </defs>
                </svg>

                <Heading mt={1} mb={3}>
                  Gut Reset Program
                </Heading>
                <Text style={{ fontSize: '14px' }}>✔ 1 nutritionist visit per month</Text>
                <Text style={{ fontSize: '14px' }}>✔ Use your existing GI test or get one through us</Text>
                <Text style={{ fontSize: '14px' }} mt={3}>
                  Starting at
                </Text>
                <Text style={{ fontSize: '30px', fontWeight: 500 }}>
                  $110
                  <span style={{ fontSize: '14px', fontWeight: 300 }}>/month</span>
                </Text>

                <Button
                  mt={4}
                  variant={'primary'}
                  style={{
                    alignSelf: 'flex-start',
                    fontWeight: 300,
                    padding: '8px 42px',
                  }}
                  onClick={() => {
                    history.push('/programs/gut-reset/subscribe');
                  }}
                >
                  Get Started
                </Button>
              </Flex>
            </Card>
            <Text mt={3} style={{ fontSize: '12px', fontWeight: 300, lineHeight: '18px' }}>
              <span style={{ fontWeight: 600 }}>Note:&nbsp;</span>
              Supplements (probiotics, vitamins, etc.) and optional specialty tests such as SIBO breath testing are not included in the monthly fee.
            </Text>
          </Flex>

          <Flex flexDirection={'column'} flex={1}>
            {expandables.map((x) => {
              return <Expandable title={x.title} text={x.text} key={`built_${x.title}`} />;
            })}
          </Flex>
        </Flex>
        <Heading mt={4} mb={4}>
          How It Works
        </Heading>
        <HowItWorks />
        <Text
          style={{
            alignSelf: 'center',
            fontSize: '18px',
            fontWeight: 500,
          }}
          mt={5}
          mb={3}
        >
          Start your Gut Reset Today
        </Text>
        <Button
          variant={'primary'}
          style={{
            alignSelf: 'center',
            fontWeight: 300,
            padding: '8px 42px',
          }}
          onClick={() => {
            history.push('/programs/gut-reset/subscribe');
          }}
        >
          Get Started
        </Button>
        <Heading mt={5} mb={4} alignSelf={'center'}>
          GI Reset Program Pricing
        </Heading>
        <Text style={{ maxWidth: '460px', textAlign: 'center' }} alignSelf={'center'} mb={4}>
          What You Get With the GI Reset Program
        </Text>

        <Flex justifyContent="center" alignItems="center">
          <PricingCards
            onClick={() => {
              history.push('/programs/gut-reset/subscribe');
            }}
          />
        </Flex>
        <Heading mt={5} mb={4} alignSelf={'center'}>
          Frequently Asked questions
        </Heading>
        <Flex flexDirection={'column'} style={{ width: '325px', maxWidth: '325px', alignSelf: 'center' }}>
          {faq.map((x) => {
            return <Expandable title={x.title} text={x.text} key={`faq_${x.title}`} />;
          })}
        </Flex>
      </Flex>
    );
  })
);
